<template>
<div :style="{ height: `${vh - 170}px` }" class="flex align-items-center justify-content-center pt-3 pb-3">
  <ul  class="list-none p-2 m-2 surface-ground">

    <li class="flex justify-content-center align-items-center mt-2 mb-5">
      <a v-if="store.token != '' && (store.user.department.id == 3 || store.user.department.id == 2)" href="javascript:void(0);"  @click="setRoute('mod-orders/orders')" >
        <PrimevueButton label="OBJEDNÁVKY" severity="primary" text raised class="basic-menu"/>
      </a>
    </li>
    <li class="flex justify-content-center align-items-center mt-2 mb-2">
      <a v-if="store.token != '' && (store.user.department.id == 3 || store.user.department.id == 1)" href="javascript:void(0);"  @click="setRoute('mod-stock')">
        <PrimevueButton label="SKLAD" severity="primary" text raised class="basic-menu"/>
      </a>
    </li>

  </ul>
</div>
</template>

<script lang="ts">

import Security from './security'
import {store} from './store'
import {Models} from "@/components/models";
import router from "@/router";
import PrimevueButton from 'primevue/button';

export default {
  name: 'EfirmaHome',
  components:{
      PrimevueButton,

  },
    data() {
      return {
      store,
      vh: 0,
    }
  },
    beforeMount() {
      
      Security.requireToken();
      //store.selectModul = this.$route.path.split("/")[1]
      this.store.order = {...this.store.order_default};
      const orderHistoryEmpty: Models.OrderHistory[] = [];
      this.store.orderHistory = orderHistoryEmpty;
      this.setDynamicHeight(); 
      // Aktualizácia výšky pri zmene veľkosti okna
      window.addEventListener("resize", this.setDynamicHeight);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.setDynamicHeight);
  },

  methods: {
    setRoute(param: string){
      store.selectModul = param;
      router.push({path: '/'+param})
    },

    setDynamicHeight() {
      this.vh = window.innerHeight; // Nastavenie viditeľnej výšky
    },

  },
}    
</script>